import { useFormBuilderContextState } from 'components/FormBuilder/context';
import { TextErrors } from 'components/FormBuilder/schemas';

import { isTextDataField } from './helpers';

export const useTextDataField = () => {
  const { values, errors, ...rest } = useFormBuilderContextState();

  if (!isTextDataField(values)) {
    throw new Error(
      `useTextDataField must be used where a text field input is expected, instead input of type: ${values.type} was received.`,
    );
  }

  return {
    ...rest,
    values,
    errors: errors as TextErrors,
  };
};
